import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Icon } from '../Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var DwgSvg = function DwgSvg() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#F1D2CF",
      d: "M20.333 2H3.667C2.747 2 2 2.746 2 3.667v16.666C2 21.253 2.746 22 3.667 22h16.666c.92 0 1.667-.746 1.667-1.667V3.667C22 2.747 21.254 2 20.333 2"
    }), /*#__PURE__*/_jsx("path", {
      fill: "url(#prefix__a)",
      fillRule: "evenodd",
      d: "m13.776 15.889.34 1.944h1.659l1.552-1.944z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "url(#prefix__b)",
      fillRule: "evenodd",
      d: "M17.834 15.889h-2.029v1.944h1.015z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "url(#prefix__c)",
      fillRule: "evenodd",
      d: "M9.718 15.403h-2.67l-.374.644 1.022 1.786h1.551l.453-1.685.018-.067z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#561210",
      fillRule: "evenodd",
      d: "M7.688 16.375H6.167l1.361 1.454h.16z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#1F0F10",
      fillRule: "evenodd",
      d: "M7.688 16.375v-1.948L6.334 15.54l-.167.836z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "url(#prefix__d)",
      fillRule: "evenodd",
      d: "m15.805 12.735-3.607-6.568-4.51 8.263z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "url(#prefix__e)",
      fillRule: "evenodd",
      d: "m7.688 14.428 7.488-2.866 1.136 4.327H7.688z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#381413",
      fillRule: "evenodd",
      d: "m15.15 11.556.807 4.333h1.877l-.886-3.768z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "url(#prefix__f)",
      fillRule: "evenodd",
      d: "m10.143 13.518 3.119-1.153-1.19-6.198z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "url(#prefix__g)",
      fillRule: "evenodd",
      d: "m13.263 12.306.52 3.59H9.71l.43-2.383z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("linearGradient", {
        id: "prefix__a",
        x1: 14.447,
        x2: 14.891,
        y1: 17.258,
        y2: 16.336,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#9A1E21"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.184,
          stopColor: "#AF2424"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.408,
          stopColor: "#C32A27"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.561,
          stopColor: "#CA2D28"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "prefix__b",
        x1: 16.82,
        x2: 16.82,
        y1: 15.889,
        y2: 17.833,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#A41E22"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#A51F23"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "prefix__c",
        x1: 8.196,
        x2: 8.196,
        y1: 15.403,
        y2: 17.833,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: 0.074,
          stopColor: "#B42626"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.337,
          stopColor: "#B02525"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.62,
          stopColor: "#A52222"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.912,
          stopColor: "#931C1E"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#8C191C"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "prefix__d",
        x1: 11.747,
        x2: 11.747,
        y1: 12.549,
        y2: 7.22,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#7E1519"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.045,
          stopColor: "#84171A"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.263,
          stopColor: "#9D2021"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.477,
          stopColor: "#AF2524"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.684,
          stopColor: "#BA2826"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.877,
          stopColor: "#BE2927"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#AB1F24"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "prefix__e",
        x1: 7.688,
        x2: 16.312,
        y1: 13.726,
        y2: 13.726,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#4B1614"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.312,
          stopColor: "#471514"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#421313"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "prefix__f",
        x1: 11.702,
        x2: 11.702,
        y1: 6.167,
        y2: 13.518,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#DE462F"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.447,
          stopColor: "#D8412D"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.927,
          stopColor: "#CA3228"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#C72F28"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "prefix__g",
        x1: 11.747,
        x2: 11.747,
        y1: 15.896,
        y2: 12.306,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#771315"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.065,
          stopColor: "#791416"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.621,
          stopColor: "#87181A"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#8C191C"
        })]
      })]
    })]
  });
};
export var Dwg = function Dwg(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
    component: DwgSvg
  }));
};